import { Component } from '@angular/core';

@Component({
  selector: 'mav-geomap-icon',
  templateUrl: './geomap-icon.component.html',
  styleUrls: ['./geomap-icon.component.scss']
})
export class GeomapIconComponent {

  constructor() { }
}
